// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e674547c","195":"ef84ab06","205":"37a33a1b","236":"67ee587e","267":"17dfec35","312":"7fd23a93","404":"ca65cdfa","605":"9b30b218","606":"d1f95c2f","633":"c3d87cc9","795":"e73fd103","807":"ec4d24f3","855":"afbfc9a5","869":"8ecf5138","965":"2be873e9"}[chunkId] + ".chunk.js";
};